var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "panel-bg"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "bar"
  }), _c('div', {
    staticClass: "ctx"
  }, [_vm._t("default")], 2)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };